<template>
  <div class="settings-design">
    <div v-if="!addonActive" class="addon-gate">
      <div class="addon-gate-left">
        <div class="addon-gate-icon"><svg viewBox="0 0 24 24"><path d="M12 22s8-4 8-10V5l-8-3-8 3v7c0 6 8 10 8 10z"/></svg></div>
        <div>
          <div class="addon-gate-title">DAC7 &amp; VAT compliance — add-on required</div>
          <div class="addon-gate-sub">DAC7 compliance tracking, HMRC reporting exports, owner compliance monitoring, and Xero VAT integration are part of the VAT &amp; compliance add-on. Owner setup links and collecting owner details are always free.</div>
          <span class="addon-gate-price">+£1 per property per month · many managers recover this from owners</span>
        </div>
      </div>
      <button class="btn btn-upgrade" @click="addonActive = true">
        <svg viewBox="0 0 24 24"><path d="M12 2l3.09 6.26L22 9.27l-5 4.87 1.18 6.88L12 17.77l-6.18 3.25L7 14.14 2 9.27l6.91-1.01L12 2z"/></svg>
        Activate add-on
      </button>
    </div>

    <div v-if="addonActive">
      <div class="compliance-tile-strip">
        <div class="compliance-tile">
          <div class="compliance-tile-label">Owners complete</div>
          <div class="compliance-tile-value green">5 <span style="font-size:1rem;color:var(--text-muted);">/ 9</span></div>
          <div class="compliance-tile-sub">4 still need to complete their details</div>
          <div class="compliance-tile-cta">View in Properties <svg viewBox="0 0 24 24"><path d="M5 12h14M12 5l7 7-7 7"/></svg></div>
        </div>
        <div class="compliance-tile">
          <div class="compliance-tile-label">Details missing</div>
          <div class="compliance-tile-value amber">4</div>
          <div class="compliance-tile-sub">Owner info not yet submitted</div>
          <div class="compliance-tile-cta">Send setup links <svg viewBox="0 0 24 24"><path d="M5 12h14M12 5l7 7-7 7"/></svg></div>
        </div>
        <div class="compliance-tile">
          <div class="compliance-tile-label">Action needed</div>
          <div class="compliance-tile-value red">1</div>
          <div class="compliance-tile-sub">The Lookout — incomplete details</div>
          <div class="compliance-tile-cta">Fix now <svg viewBox="0 0 24 24"><path d="M5 12h14M12 5l7 7-7 7"/></svg></div>
        </div>
      </div>

      <div style="padding:12px 16px;background:var(--accent-dim);border:1px solid var(--accent-border);border-radius:var(--radius);margin-bottom:20px;font-size:12px;color:var(--text-mid);line-height:1.7;">
        <strong style="color:var(--text);">All owners must be reported — there is no minimum earnings threshold under UK rules.</strong> UK digital platform reporting rules require every property owner to be reported annually, regardless of how much they earn. Owner details must be complete for every property. The next reporting deadline is <strong>31 January 2027</strong>. Penalty for non-compliance is £5,000 per HMRC notice.
      </div>
      <div class="card">
        <div class="card-header">
          <div>
            <div class="card-title card-title-addon"><svg viewBox="0 0 24 24"><path d="M12 22s8-4 8-10V5l-8-3-8 3v7c0 6 8 10 8 10z"/></svg>Reporting requirements</div>
            <div class="card-subtitle">UK rules · all owners reportable — no minimum threshold</div>
          </div>
          <span class="addon-tag"><svg viewBox="0 0 24 24"><path d="M12 2l3.09 6.26L22 9.27l-5 4.87 1.18 6.88L12 17.77l-6.18 3.25L7 14.14 2 9.27l6.91-1.01L12 2z"/></svg>Add-on</span>
        </div>
        <div class="card-body">
          <div class="field-grid" style="margin-bottom:16px;">
            <div style="padding:12px 14px;background:var(--bg);border-radius:8px;border:1px solid var(--border);">
              <div style="font-size:10px;font-weight:700;text-transform:uppercase;letter-spacing:0.07em;color:var(--text-muted);margin-bottom:6px;">Annual reporting deadline</div>
              <div style="font-family:'Outfit',sans-serif;font-size:1.3rem;font-weight:800;color:var(--text);">31 Jan 2027</div>
              <div style="font-size:11px;color:var(--text-muted);margin-top:3px;">Covering 2026 calendar year activity</div>
            </div>
            <div style="padding:12px 14px;background:var(--red-dim);border-radius:8px;border:1px solid var(--red-border);">
              <div style="font-size:10px;font-weight:700;text-transform:uppercase;letter-spacing:0.07em;color:var(--text-muted);margin-bottom:6px;">Non-compliance penalty</div>
              <div style="font-family:'Outfit',sans-serif;font-size:1.3rem;font-weight:800;color:var(--red);">£5,000</div>
              <div style="font-size:11px;color:var(--text-muted);margin-top:3px;">Per HMRC notice — per property manager</div>
            </div>
          </div>
          <div class="toggle-row">
            <div class="toggle-info">
              <strong>Block sending reports if identity document is missing</strong>
              <span>Prevents a report being sent to any owner who hasn't submitted a passport or driving licence</span>
            </div>
            <label class="toggle"><input type="checkbox" v-model="blockIfNoId"/><div class="toggle-track"></div><div class="toggle-thumb"></div></label>
          </div>
          <div class="toggle-row">
            <div class="toggle-info">
              <strong>Notify me when an owner's details become incomplete</strong>
              <span>Alert if a previously verified owner's information is flagged or needs updating</span>
            </div>
            <label class="toggle"><input type="checkbox" v-model="notifyIncomplete"/><div class="toggle-track"></div><div class="toggle-thumb"></div></label>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'Dac7Tab',
  data() {
    return {
      addonActive: false,
      blockIfNoId: true,
      notifyIncomplete: true
    };
  }
};
</script>

<style scoped>
.settings-design {
  --accent: #5b4fcf;
  --accent-dim: rgba(91,79,207,0.08);
  --accent-border: rgba(91,79,207,0.25);
  --bg: #f5f4fb;
  --white: #ffffff;
  --text: #1a1a2e;
  --text-mid: #4a4880;
  --text-muted: #9896bb;
  --border: #e8e6f4;
  --green: #00b894;
  --green-dim: rgba(0,184,148,0.1);
  --green-border: rgba(0,184,148,0.25);
  --amber: #fdcb6e;
  --amber-text: #b7791f;
  --amber-dim: rgba(253,203,110,0.2);
  --amber-border: rgba(253,203,110,0.5);
  --red: #d63031;
  --red-dim: rgba(214,48,49,0.08);
  --red-border: rgba(214,48,49,0.2);
  --gold: #f59e0b;
  --gold-dim: rgba(245,158,11,0.1);
  --gold-border: rgba(245,158,11,0.3);
  --shadow-sm: 0 1px 4px rgba(26,24,61,0.07);
  --radius: 10px;
  font-family: 'Inter', sans-serif;
  font-size: 14px;
  color: var(--text);
  -webkit-font-smoothing: antialiased;
}
.settings-design *, .settings-design *::before, .settings-design *::after { box-sizing: border-box; }

/* ADDON GATE */
.addon-gate { background: var(--white); border: 1.5px solid var(--gold-border); border-radius: var(--radius); padding: 18px 22px; margin-bottom: 20px; display: flex; align-items: center; justify-content: space-between; gap: 20px; flex-wrap: wrap; }
.addon-gate-left { display: flex; align-items: flex-start; gap: 14px; }
.addon-gate-icon { width: 38px; height: 38px; border-radius: 9px; background: var(--gold-dim); display: flex; align-items: center; justify-content: center; flex-shrink: 0; }
.addon-gate-icon svg { width: 18px; height: 18px; fill: none; stroke: var(--gold); stroke-width: 2; stroke-linecap: round; }
.addon-gate-title { font-family: 'Outfit', sans-serif; font-size: 0.95rem; font-weight: 700; color: var(--text); margin-bottom: 3px; }
.addon-gate-sub { font-size: 12px; color: var(--text-muted); line-height: 1.5; max-width: 480px; }
.addon-gate-price { font-size: 11px; font-weight: 700; color: #92400e; background: var(--gold-dim); border: 1px solid var(--gold-border); border-radius: 20px; padding: 3px 10px; white-space: nowrap; margin-top: 6px; display: inline-block; }
.addon-tag { display: inline-flex; align-items: center; gap: 5px; font-size: 10px; font-weight: 700; padding: 2px 8px; border-radius: 20px; background: var(--gold-dim); color: #92400e; border: 1px solid var(--gold-border); white-space: nowrap; }
.addon-tag svg { width: 10px; height: 10px; fill: none; stroke: currentColor; stroke-width: 2; }

/* CARDS */
.card { background: var(--white); border-radius: var(--radius); border: 1px solid var(--border); box-shadow: var(--shadow-sm); overflow: hidden; margin-bottom: 18px; }
.card-header { padding: 16px 22px; border-bottom: 1px solid var(--border); display: flex; align-items: center; justify-content: space-between; gap: 12px; flex-wrap: wrap; }
.card-title { font-family: 'Outfit', sans-serif; font-size: 0.9rem; font-weight: 700; color: var(--text); display: flex; align-items: center; gap: 8px; }
.card-title svg { width: 15px; height: 15px; fill: none; stroke: var(--accent); stroke-width: 2; stroke-linecap: round; stroke-linejoin: round; }
.card-title-addon svg { stroke: var(--gold); }
.card-subtitle { font-size: 12px; color: var(--text-muted); margin-top: 2px; }
.card-body { padding: 20px 22px; }

/* FIELDS */
.field-grid { display: grid; grid-template-columns: 1fr 1fr; gap: 14px; }

/* BUTTONS */
.btn { display: inline-flex; align-items: center; gap: 6px; padding: 8px 16px; border-radius: 8px; font-size: 13px; font-weight: 600; cursor: pointer; border: none; font-family: 'Inter', sans-serif; transition: opacity 0.15s, transform 0.1s; white-space: nowrap; }
.btn:hover { opacity: 0.88; }
.btn:active { transform: scale(0.98); }
.btn-upgrade { background: var(--gold); color: #fff; }
.btn-upgrade:hover { opacity: 0.9; }
.btn svg { width: 13px; height: 13px; fill: none; stroke: currentColor; stroke-width: 2; stroke-linecap: round; }

/* COMPLIANCE TILES */
.compliance-tile-strip { display: grid; grid-template-columns: repeat(3,1fr); gap: 12px; margin-bottom: 20px; }
.compliance-tile { background: var(--white); border: 1px solid var(--border); border-radius: var(--radius); padding: 16px 18px; box-shadow: var(--shadow-sm); cursor: pointer; transition: border-color 0.15s; }
.compliance-tile:hover { border-color: var(--accent); }
.compliance-tile-label { font-size: 10px; font-weight: 700; text-transform: uppercase; letter-spacing: 0.07em; color: var(--text-muted); margin-bottom: 8px; }
.compliance-tile-value { font-family: 'Outfit', sans-serif; font-size: 1.8rem; font-weight: 800; line-height: 1; }
.compliance-tile-value.green { color: var(--green); }
.compliance-tile-value.amber { color: var(--amber-text); }
.compliance-tile-value.red { color: var(--red); }
.compliance-tile-sub { font-size: 11px; color: var(--text-muted); margin-top: 5px; }
.compliance-tile-cta { font-size: 11px; color: var(--accent); font-weight: 600; margin-top: 8px; display: flex; align-items: center; gap: 4px; }
.compliance-tile-cta svg { width: 11px; height: 11px; fill: none; stroke: currentColor; stroke-width: 2.5; }

/* TOGGLE */
.toggle-row { display: flex; align-items: center; justify-content: space-between; padding: 12px 0; border-bottom: 1px solid #f0eef8; gap: 16px; }
.toggle-row:last-child { border-bottom: none; }
.toggle-info strong { display: flex; align-items: center; gap: 8px; font-size: 13px; font-weight: 600; color: var(--text); margin-bottom: 2px; }
.toggle-info span { font-size: 11px; color: var(--text-muted); }
.toggle { position: relative; width: 36px; height: 20px; flex-shrink: 0; }
.toggle input { opacity: 0; width: 0; height: 0; position: absolute; }
.toggle-track { position: absolute; inset: 0; background: var(--border); border-radius: 10px; cursor: pointer; transition: background 0.2s; }
.toggle input:checked + .toggle-track { background: var(--accent); }
.toggle-thumb { position: absolute; top: 2px; left: 2px; width: 16px; height: 16px; background: #fff; border-radius: 50%; transition: transform 0.2s; pointer-events: none; box-shadow: 0 1px 3px rgba(0,0,0,0.2); }
.toggle input:checked ~ .toggle-thumb { transform: translateX(16px); }
</style>
